module.exports = __webpack_public_path__ + "img/NX_Step_3.1ff5a2af.png";